import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=69736ff4&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=69736ff4&prod&scoped=true&lang=css&external"
import style1 from "./Invoices.vue?vue&type=style&index=1&id=69736ff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69736ff4",
  null
  
)

export default component.exports